<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{ t("operater") }}</a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("datastatistics")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 15%"
        v-model:value="dataList.keyWord"
        :placeholder="t('supportvintagname')"
      />
      <a-button class="searchBtn" @click="hadnleSearch">{{
        t("search")
      }}</a-button>

      <a-select
        v-model:value="optionValue"
        style="width: 10%; margin: 0 20px"
        @change="getListData"
      >
        <a-select-option
          v-for="item in onLineStatusOptions"
          :key="item.value"
          v-model:value="item.value"
        >
          {{ item.label }}</a-select-option
        >
      </a-select>
      {{ t("time") }}：<a-range-picker
        v-model:value="timeValue"
        @change="changeTime"
        :allowClear="false"
        ><template #suffixIcon> <CalendarOutlined /> </template
      ></a-range-picker>
      <a-button class="searchBtn addBtn" @click="downLoadRawList">{{
        t("rawdatadownload")
      }}</a-button>
      <a-button class="searchBtn addBtn" @click="downLoadList">{{
        t("statisticaldatadownload")
      }}</a-button>
    </div>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 2000 }"
    >
      <template v-slot:bodyCell="{ column, index, record }">
        <template v-if="column.key === 'index'"> {{ index + 1 }}</template>
        <template v-if="column.key === 'controls'">
          <a-button type="link" @click="goToCarData(record.vin)">{{
            t("singlecardatastatistics")
          }}</a-button></template
        >
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(totalNum) => `${t('intotal')} ${totalNum} ${t('article')}`"
      v-model:current="dataList.page"
      v-model:pageSize="dataList.size"
      :total="totalNum"
      size="small"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { fromatDateYMD } from "@/utils/MyUtils";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default {
  name: "DataStatistics",
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const dataSource = ref();
    const totalNum = ref(0);
    const optionValue = ref("");
    const timeValue = ref();
    const setDefaultTime = () => {
      const end = dayjs();
      const start = dayjs().subtract(7, "day");
      timeValue.value = [start, end];
    };
    const onLineStatusOptions = ref([
      {
        value: "",
        label: t("whole"),
      },
      {
        value: "SC50",
        label: "SC50",
      },
      {
        value: "SC80",
        label: "SC80",
      },
      {
        value: "V50",
        label: "V50",
      },
    ]);
    const dataList = ref({
      keyWord: "",
      page: 1,
      size: 10,
      totalN: 0,
    });
    const router = useRouter();
    const getListData = () => {
      const param = {
        page: dataList.value.page,
        size: dataList.value.size,
        start_time: fromatDateYMD(timeValue.value[0].toDate()),
        end_time: fromatDateYMD(timeValue.value[1].toDate()),
      };
      optionValue.value ? (param.vehicle_type = optionValue.value) : "";
      dataList.value.keyWord ? (param.keyword = dataList.value.keyWord) : "";
      Api.getCarsTaskStatistics(param).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          totalNum.value = res.totalNum * 1;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const handlePaginationChange = (page, pageSize) => {
      dataList.value.page = page;
      dataList.value.size = pageSize;
      getListData();
    };
    const hadnleSearch = () => {
      dataList.value.page = 1;
      getListData();
    };
    const changeTime = () => {
      getListData();
    };
    const goToVehicleInfo = (id) => {
      router.push({
        path: routerName.OrgUserManagement,
        query: { id: id },
      });
    };
    const downLoadRawList = () => {
      const param = new Object();
      param.start_time = fromatDateYMD(timeValue.value[0].toDate());
      param.end_time = fromatDateYMD(timeValue.value[1].toDate());
      param.vehicle_type = optionValue.value ? optionValue.value : "";
      param.keyword = dataList.value.keyWord ? dataList.value.keyWord : "";
      Api.downloadRawCarsTaskStatistics(param);
    };
    const downLoadList = () => {
      const param = new Object();
      param.start_time = fromatDateYMD(timeValue.value[0].toDate());
      param.end_time = fromatDateYMD(timeValue.value[1].toDate());
      param.vehicle_type = optionValue.value ? optionValue.value : "";
      param.keyword = dataList.value.keyWord ? dataList.value.keyWord : "";
      Api.downloadCarsTaskStatistics(param);
    };
    const goToCarData = (vin) => {
      router.push({
        path: routerName.cardatastatistics,
        query: { vin },
      });
    };
    onMounted(() => {
      setDefaultTime();
      getListData();
    });

    return {
      dataSource,
      columns: [
        {
          title: t("serialnumber"),
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 150,
        },
        {
          title: "VIN",
          dataIndex: "vin",
          key: "vin",
          align: "center",
        },
        {
          title: t("vehiclename"),
          dataIndex: "vehicle_name",
          key: "vehicle_name",
          align: "center",
        },
        {
          title: t("customer"),
          dataIndex: "project_name",
          key: "project_name",
          align: "center",
        },
        {
          title: t("numberoftasks"),
          dataIndex: "task_num",
          key: "task_num",
          align: "center",
        },
        {
          title: t("tasktimeconsumption"),
          dataIndex: "total_time",
          key: "total_time",
          align: "center",
        },
        {
          title: t("plannedcleaningaream2"),
          dataIndex: "plan_clean_area",
          key: "plan_clean_area",
          align: "center",
        },
        {
          title: t("actualcleaningaream2"),
          dataIndex: "actual_clean_area",
          key: "actual_clean_area",
          align: "center",
        },
        {
          title: t("uncleanedaream2"),
          dataIndex: "uncleaned_area",
          key: "uncleaned_area",
          align: "center",
        },
        {
          title: t("operate"),
          dataIndex: "controls",
          key: "controls",
          align: "center",
        },
      ],
      dataList,
      totalNum,
      handlePaginationChange,
      hadnleSearch,
      goToVehicleInfo,
      getListData,
      optionValue,
      onLineStatusOptions,
      timeValue,
      changeTime,
      downLoadRawList,
      downLoadList,
      goToCarData,
      maxHeight,
      t,
    };
  },
};
</script>
<style scoped>
:deep(.ant-picker-suffix) {
  position: absolute;
  color: #4f6bff;
}
:deep(.ant-picker-input-active) {
  margin-left: 30px;
  width: calc(100% - 30px);
}
</style>
